import * as React from 'react';
import { observer } from 'mobx-react';
import { NumberPanel } from '@ixicare/ui';
import { t } from '~/i18n';
import { useStores } from '~store/utils';

// Fetching is driven by DashboardPage on selectedSite change so the numbers
// reflect the currently viewed site.
const DashboardNumbersContainer: React.FC = observer(() => {
  const { graphs } = useStores();
  const { numberOfResidents, numberOfResidentGroups, numberOfhealthcareProviders, numberOfhealthcareProviderGroups } =
    graphs.global;

  return (
    <div className="row">
      <div className="col-6 col-xl-3">
        <NumberPanel number={numberOfResidents} label={t('dashboard.numbers.residents')} icon="user" />
      </div>
      <div className="col-6 col-xl-3">
        <NumberPanel
          number={numberOfResidentGroups}
          label={t('dashboard.numbers.resident_groups')}
          icon="resident-groups"
        />
      </div>
      <div className="col-6 col-xl-3">
        <NumberPanel
          number={numberOfhealthcareProviders}
          label={t('dashboard.numbers.healthcare_providers')}
          icon="healthcare-providers"
        />
      </div>
      <div className="col-6 col-xl-3">
        <NumberPanel
          number={numberOfhealthcareProviderGroups}
          label={t('dashboard.numbers.healthcare_provider_groups')}
          icon="healthcare-provider-groups"
        />
      </div>
    </div>
  );
});

export default DashboardNumbersContainer;
